// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import cartLineSharedStyles from "@conklin/App/SharedStyles/CartLineSharedStyles";
import { discontinuedProductListLineStyles } from "@conklin/Overrides/Widgets/MyListsDetails/MyListDetailsDiscontinuedProductListLine";
import { mergeWithCss, sharedProductDescriptionStyles, xScreen } from "@conklin/XDL/Utilities";
import X from "@insite/mobius/Icons/X";
import { css } from "styled-components";

discontinuedProductListLineStyles.restrictedDescriptionText = {
    ...sharedProductDescriptionStyles().productDetailDescription,
};

discontinuedProductListLineStyles.productPartNumbersStyles = {
    ...mergeWithCss(cartLineSharedStyles.productPartNumbers, {
        container: {
            css: css`
                margin-bottom: 0;
            `,
        },
    }),
};

discontinuedProductListLineStyles.chipTypographyStyles = {
    css: css`
        margin: 12px 0;
        ${xScreen("lte", "md")} {
            max-width: 255px;
            min-width: 255px;
        }
        ${xScreen("lte", "sm")} {
            max-width: unset;
            min-width: unset;
        }
    `,
};

discontinuedProductListLineStyles.deleteLink = {
    icon: {
        iconProps: {
            src: X,
            size: 12,
            css: css`
                margin-right: 6px;
            `,
        },
    },
    typographyProps: {
        size: 12,
        lineHeight: "14px,",
    },
    css: css`
        display: flex;
        justify-content: center;
        margin-left: auto;
        margin-top: 8px;
        width: 100%;
        justify-content: flex-end;
        ${xScreen("lte", "md")} {
            margin-top: 12px;
        }
        &:focus {
            outline: none;
        }
    `,
};
